module.exports = __webpack_public_path__ + "media/crypto/snx-6856f950.png";